import React from 'react';
import { Container, Button, Card, Image } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './lucky.css';
import {useNavigate} from "react-router-dom";


const randomColor = () =>{
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const daysOfWeek = ["일", "월", "화", "수", "목", "금", "토"];
    const dayOfWeek = daysOfWeek[date.getDay()];

    return `${year}년 ${month}월 ${day}일 (${dayOfWeek})`;
}

const Lucky = () => {
    const navigate = useNavigate()
    return (
        <Container className="container d-flex flex-column align-items-center justify-content-center">
            <div className="clover-container">
                <Image
                    src={`${process.env.PUBLIC_URL}/logo.png`}
                    alt="네잎클로버"
                    className="clover-image"
                    roundedCircle
                />
            </div>
            <Card className="text-center p-4 mt-3" style={{ width: '100%', maxWidth: '350px' }}>
                <Card.Body>
                    <Card.Title style={{ color: randomColor() }}>{getCurrentDate()}</Card.Title>
                    <Card.Title className="font-weight-bold">오늘의 운세</Card.Title>
                    <Card.Text>
                        오늘의 운세를 확인해보세요!
                    </Card.Text>
                    <Button variant="outline-success" size="lg" className="w-100" onClick={()=> navigate('/luckyDetail')}>
                        운세 확인
                    </Button>
                </Card.Body>
            </Card>
        </Container>
    );
}

export default Lucky;
